<template>
  <section class="form-list">
    <div class="table-title table-title-top">任务完成列表</div>

    <v-table
      :count="count"
      :list="list"
      :is-loading="isLoading"
      :push-list="RouteConfig.integralActivityTargetEntityReceiveManage.push"
      :query-list="queryList"
      :is-show-store-select="true"
      :is-store-select-clearable="true"
      :has-private-store="true"
      store-select-label="任务完成门店"
      :is-show-student-select="true"
      student-select-label="任务完成学员"
      :is-not-top-list="true"
    >
      <v-column-time value="完成时间" field="add_time" sort-field="id" align="center"/>

      <el-table-column label="完成门店" prop="store_name_target" align="center" width="150px"/>

      <v-column-student label="学员" link-page-id="student_id" align="center"/>

      <template v-if="activity.entity_count">
        <v-column-time value="实物领取时间" field="add_time_entity" align="center" sortable=""/>

        <el-table-column label="领取门店" width="150px" align="center">
          <template v-slot="{ row }">{{ row.store_name || '-' }}</template>
        </el-table-column>

        <el-table-column label="领取状态" width="150px" align="center">
          <template v-slot="{ row }">
            <el-tag v-if="row.is_received" type="success">已领取</el-tag>
            <el-tag v-else>待领取</el-tag>
          </template>
        </el-table-column>

        <v-column-admin label="操作者" align="center"/>

        <el-table-column label="操作">
          <template v-slot="{ row }">
            <v-list-button
              v-if="row.is_received"
              name="取消领取"
              icon="sign-canceled"
              size="large"
              :is-last="true"
              @click="handleCancelReceive(row)"
              :is-loading="isCancellingIds.includes(row.id)"
              message="确认要取消该学员的领取吗？"
            />

            <v-list-button
              v-else
              name="确认领取"
              icon="signed-in"
              size="large"
              :is-last="true"
              @click="handleReceive(row)"
              :is-loading="isCancellingIds.includes(row.student_id)"
              message="确认该学员要领取实物奖励吗？"
            />
          </template>
        </el-table-column>
      </template>


      <template slot="mobile-list">
        <section class="list">
          <template v-if="list.length">
            <div
              v-for="(v, k) in list"
              :key="`integral-activity-target-entity-receive-${k}-${v.id}`"
              class="list-item primary-background-light"
            >
              <div class="list-item-detail">
                <span>完成时间</span>
                <span>{{ v.add_time | timeToYmdHi }}</span>
              </div>
              <div class="list-item-detail">
                <span>完成门店</span>
                <span>{{ v.store_name_target }}</span>
              </div>
              <div class="list-item-detail">
                <span>学员</span>
                <v-avatar-nickname
                  :value="v.selfie"
                  :nickname="v.student_name"
                  :link-page-name="RouteConfig.studentDetail.name"
                  :link-page-id="v.student_id"
                  :avatar-size="50"
                  width="30vw"
                />
              </div>
              <template v-if="activity.entity_count">
                <div class="list-item-detail">
                  <span>实物领取时间</span>
                  <span>{{ v.add_time_entity | timeToYmdHi }}</span>
                </div>
                <div class="list-item-detail">
                  <span>领取门店</span>
                  <span>{{ v.store_name || '-' }}</span>
                </div>
                <div class="list-item-detail">
                  <span>领取状态</span>
                  <el-tag v-if="v.is_received" type="success">已领取</el-tag>
                  <el-tag v-else>待领取</el-tag>
                </div>
                <div class="list-item-detail">
                  <span>操作者</span>
                  <v-avatar-nickname
                    :value="v.administrator_avatar"
                    :nickname="v.administrator_nickname"
                    :avatar-size="50"
                    width="30vw"
                  />
                </div>
                <div class="list-item-button">
                  <v-list-button
                    v-if="v.is_received"
                    name="取消领取"
                    icon="sign-canceled"
                    size="large"
                    :is-last="true"
                    @click="handleCancelReceive(v)"
                    :is-loading="isCancellingIds.includes(v.id)"
                    message="确认要取消该学员的领取吗？"
                  />

                  <v-list-button
                    v-else
                    name="确认领取"
                    icon="signed-in"
                    size="large"
                    :is-last="true"
                    @click="handleReceive(v)"
                    :is-loading="isCancellingIds.includes(v.student_id)"
                    message="确认该学员要领取实物奖励吗？"
                  />
                </div>
              </template>
            </div>
          </template>
          <v-empty :is-loading="isLoading" :length="list.length"/>
        </section>
      </template>
    </v-table>

    <div class="table-title">目标详情</div>
    <el-form class="form form-max" ref="form" label-width="100px" :rules="rules" :model="post">
      <el-form-item label="所属活动">
        <span class="title">{{ activity.title }}</span>
      </el-form-item>

      <el-form-item label="挑战目标">
        <span class="title">{{ activity.brief_target }}</span>
      </el-form-item>

      <el-form-item label="开始时间">
        <span class="title">{{ activity.start_time | timeToYmdHi }}</span>
      </el-form-item>

      <el-form-item label="结束时间">
        <span class="title">{{ activity.end_time | timeToYmdHi }}</span>
      </el-form-item>


      <el-form-item label="实物奖励名称">
        <span class="title">{{ activity.entity_name }}</span>
      </el-form-item>

      <el-form-item label="实物奖励图片">
        <div class="entity-cover" style="width: 100px;height:100px">
          <v-img :value="activity.entity_cover"/>
        </div>
      </el-form-item>

      <el-form-item label="奖励积分">
        <span class="title">
          <span class="primary-color count-number sign-in-count">{{ activity.integral | toYuan }}</span> 分
        </span>
      </el-form-item>

      <el-form-item label="实物奖励总数">
        <span class="success-color count-number sign-in-count">{{ activity.entity_count }}</span>
      </el-form-item>

      <el-form-item label="领取人数统计">
        <div class="count-box">
          <span class="primary-color count-number sign-in-count">{{ activity.entity_received_count }}</span>
        </div>
      </el-form-item>

      <el-form-item class="last-form-item">
        <el-button @click="RouteConfig.integralActivityTargetList.push">返回目标列表</el-button>
      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { removeArrayItem } from "@/utils";
import { getLegalQueryList } from "@/utils/formats";
import { show, getEntityReceiveList, receiveEntity, cancelReceiveEntity } from '@/api/integral-activity-target';

export default {
  name: RouteConfig.integralActivityTargetEntityReceiveManage.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isReceiving: false,
    isCancellingIds: [],
    post: {
      student_id: 0,
    },
    count: 0,
    list: [],
    activity: {
      activity_type: 0,
      title: '',
      entity_cover: '',
      entity_name: '',
      entity_count: 0,
      entity_received_count: 0,
      integral: '',
      start_time: '',
      end_time: '',
      brief_target: '',
    },
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
      refresh_tag: 0,
    },
    rules: {
      student_id: [{ required: true, message: '请选择所属学员', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  watch: {
    '$route'(to) {
      this.show();
      this.load(to);
    },
  },
  beforeMount() {
    this.show();
    this.load();
  },
  methods: {
    refresh() {
      this.queryList.page = 1;
      this.queryList.refresh_tag++;
      RouteConfig.integralActivityTargetEntityReceiveManage.push(this.queryList);
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getEntityReceiveList(this.id, queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { activity } = this;
      Object.keys(data).forEach(key => {
        if (key in activity) activity[key] = data[key];
      });
    },
    async handleCancelReceive({ entity_id, del_time_entity }) {
      if (this.isCancellingIds.includes(entity_id)) return;

      this.isCancellingIds.push(entity_id);
      const { isError } = await cancelReceiveEntity(entity_id, del_time_entity);
      removeArrayItem(this.isCancellingIds, entity_id);
      if (!isError) this.refresh();
    },
    async handleReceive({ student_id }) {
      if (this.isCancellingIds.includes(student_id)) return;

      this.isCancellingIds.push(student_id);
      const { isError } = await receiveEntity(this.id, { student_id });
      removeArrayItem(this.isCancellingIds, student_id);
      if (isError) return;

      this.$message({
        message: '领取成功！',
        type: 'success',
        duration: 3000,
      });
      this.refresh();
    },
  },
};
</script>

<style scoped>
  .last-form-item {
    margin-bottom: 0;
  }

  .count-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 18px;
  }

  .count-number {
    padding: 0 6px;
    font-weight: bold;
  }

  .sign-in-count {
    font-size: 28px;
    padding-bottom: 2px;
  }

  .form-title {
    font-size: 20px;
    font-weight: bold;
  }

  .table-title {
    border-top: 3px dashed #eeeeee;
    margin-top: 16px;
    padding: 20px 0 10px 20px;
    font-size: 20px;
    font-weight: bold;
  }
  .table-title-top {
    margin-top: 0;
    border-top: 0;
  }
</style>
